import { render, staticRenderFns } from "./HomeContentBlockCheapflights.vue?vue&type=template&id=25a4985c&scoped=true"
import script from "./HomeContentBlockCheapflights.vue?vue&type=script&lang=js"
export * from "./HomeContentBlockCheapflights.vue?vue&type=script&lang=js"
import style0 from "./HomeContentBlockCheapflights.vue?vue&type=style&index=0&id=25a4985c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a4985c",
  null
  
)

export default component.exports